/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: "/doctors-registered",
    name: "Profissionais cadastrados",
    slug: "doctors-registered",
    icon: "UserCheckIcon",
    i18n: "doctors-registered"
  },
  {
    url: "/doctors-pending",
    name: "Novos cadastros",
    slug: "doctors-pending",
    icon: "UserPlusIcon",
    i18n: "doctors-pending"
  },
  {
    url: '/professionals-report',
    name: "Relatórios",
    slug: "professionals-report",
    icon: "FileTextIcon",
    i18n: "professionals-report",
    submenu: [
      {
          url: "/quicksight-doctor-dashboard",
          name: "Painéis BI",
          slug: "quicksight-doctor-dashboard",
          i18n: "quicksight-doctor-dashboard"
      },
      {
          url: "/doctor-report",
          name: "Relatório de Profissionais",
          slug: "doctor-report",
          i18n: "doctor-report"
      },
       
    ],
  
  },
]